import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unlock",
  "use": "icon-unlock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-unlock\">\n    <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(4 3)\">\n        <rect width=\"16\" height=\"10\" y=\"8\" fill=\"#4F8BFF\" rx=\"2\" />\n        <path fill=\"#FFF\" d=\"M7 11H9V15H7z\" />\n        <path stroke=\"#4F8BFF\" d=\"M3 7V4.846C3 2.17 5.239 0 8 0s5 2.17 5 4.846V7\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol